'use strict';

const $onReady = require('public/js/lib/on-ready');

const { handleGarageData } = require('public/js/components/garage-store.js');

const clearGarageCache = () => { handleGarageData.clearGarageCache(); };

function attachClickListeners() {
	rp$(document)
		.off('click.rpLogoutEvent', 'a.log-out-link')
		.on('click.rpLogoutEvent', 'a.log-out-link', clearGarageCache);

	rp$(document)
		.off('submit.rpLoginEvent', '#login-user-form')
		.on('submit.rpLoginEvent', '#login-user-form', clearGarageCache);

	rp$(document)
		.off('submit.rpCreateAccountEvent', '#create-account-user-form')
		.on('submit.rpCreateAccountEvent', '#create-account-user-form', clearGarageCache);
}

$onReady({
	rp$,
	window: globalThis,
	label: 'get-auth',
	fn: function () {
		attachClickListeners();
	},
});
